import { Store } from 'vuex'
import { AxiosError, AxiosInstance } from 'axios'
import { instanceNoAuth } from '@/model/api/apibase'
import { State as StoreState } from '@/store/index'
import API_URL from '@/model/api/apiUrlType'
import { ErrorResponse } from '@/model/api/error/erroResponse'
import { useApiError } from '@/model/api/error/apiError'
import { ErrorMsgState } from '@/model/components/common/message/errorMessage'
import { UserEntryAuthSendState } from '@/model/components/users/userEntryAuthSendState'
import { UserEntryAuthState } from '@/model/components/users/userEntryAuthState'
import { UserEntryState } from '@/model/components/users/userEntryState'

// リクエストデータ
// ワンタイムパスワード発行用
type SendRequestData = {
  // アカウント情報
  username: string
  // 処理種別
  type: string
}
// ワンタイムパスワード認証用
type AuthRequestData = {
  // アカウント情報
  username: string
  // パスワード
  password: string
  // 処理種別
  type: string
}
// パスワード登録用
type EntryRequestData = {
  // アカウント情報
  username: string
  // パスワード
  password: string
  // パスワード確認
  passwordConfirm: string
  // ワンタイムパスワード
  onetimePassword: string
  // 処理種別
  type: string
}

/**
 * ユーザーエントリーの関数を返す
 * @param store vuex
 * @returns ユーザーエントリーの関数
 */
const userEntry = (store: Store<StoreState>) => {
  // API通信インスタンス
  const instance: AxiosInstance | undefined = instanceNoAuth(store)

  /**
   * ワンタイムパスワード発行処理のAPIを実施
   * @param state 画面データ
   * @param error エラーメッセージ状態
   */
  const send = async (state: UserEntryAuthSendState, error: ErrorMsgState) => {
    // 戻り値
    // responsに戻りデータはないが、成功時に呼び元で画面遷移があるため、処理結果を明示的にリターンする
    let result = false

    // リクエストデータ設定
    const request: SendRequestData = {
      username: state.username,
      type: state.type,
    }
    // ワンタイムパスワード発行後のaxiosインスタンス取得
    const obj = instance
    await obj
      .post(
        API_URL.USERS.ENTRYAUTHSEND, // URL
        request // リクエストデータ
      )
      .then(() => {
        // 発行成功
        result = true
      })
      .catch(async (e: AxiosError<ErrorResponse>) => {
        // 異常時はエラーメッセージを設定する
        await useApiError().setbaseError(e, error)
      })
    return {
      result,
    }
  }
  /**
   * ワンタイムパスワード認証処理のAPIを実施
   * @param state 画面データ
   * @param error エラーメッセージ状態
   */
  const authenticate = async (state: UserEntryAuthState, error: ErrorMsgState) => {
    // 戻り値
    // responsに戻りデータはないが、成功時に呼び元で画面遷移があるため、処理結果を明示的にリターンする
    let result = false

    // リクエストデータ設定
    const request: AuthRequestData = {
      username: state.username,
      password: state.password,
      type: state.type,
    }
    // ワンタイムパスワード認証後のaxiosインスタンス取得
    const obj = instance
    await obj
      .post(
        API_URL.USERS.ENTRYAUTH, // URL
        request // リクエストデータ
      )
      .then(() => {
        // 認証成功
        result = true
      })
      .catch(async (e: AxiosError<ErrorResponse>) => {
        // 異常時はエラーメッセージを設定する
        await useApiError().setbaseError(e, error)
      })
    return {
      result,
    }
  }
  /**
   * パスワード登録処理のAPIを実施
   * @param state 画面データ
   * @param error エラーメッセージ状態
   */
  const entry = async (state: UserEntryState, error: ErrorMsgState) => {
    // 戻り値
    // responsに戻りデータはないが、成功時に呼び元で画面遷移があるため、処理結果を明示的にリターンする
    let result = false

    // リクエストデータ設定
    const request: EntryRequestData = {
      username: state.username,
      password: state.password,
      passwordConfirm: state.passwordConfirm,
      onetimePassword: state.onetimepassword,
      type: state.type,
    }
    // パスワード登録後のaxiosインスタンス取得
    const obj = instance
    await obj
      .post(
        API_URL.USERS.ENTRY, // URL
        request // リクエストデータ
      )
      .then(() => {
        // TODO 一旦正常時は何もしない
        // 登録成功時は正常メッセージを設定する
        // convertData('body.entry.success.message', normal)
        result = true
      })
      .catch(async (e: AxiosError<ErrorResponse>) => {
        // 異常時はエラーメッセージを設定する
        await useApiError().setbaseError(e, error)
      })
    return {
      result,
    }
  }
  return {
    instance,
    send,
    authenticate,
    entry,
  }
}

export {
  userEntry, //
}
